import SiteNav from '@/components/organisms/SiteNav';
import FooterStub from '@/components/organisms/FooterStub';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-unimo-stone text-unimo-slate">
      <div className="site-shell">
        <SiteNav />
        <main className="py-section-gap">
          <p className="mb-4 text-sm font-medium">404 · Page not found</p>
          <h1 className="max-w-2xl text-4xl font-medium lg:text-5xl">We couldn't find that page.</h1>
          <p className="mt-6 max-w-2xl text-lg font-light">The link may have changed, or the address may be incorrect.</p>
          <div className="mt-8 flex flex-wrap gap-4">
            <a href="/" className="rounded-xl bg-unimo-slate px-6 py-3 font-medium text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4">Back to home</a>
            <a href="/contact" className="rounded-xl border border-unimo-slate px-6 py-3 font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4">Contact us</a>
          </div>
        </main>
        <FooterStub />
      </div>
    </div>
  );
}
